/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import {} from 'carbon-addons-iot-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Hero.module.css';
import MonitorExternal from './svg/monitor-external-landing.svg';

const propTypes = {
  title: PropTypes.string.isRequired,
  primaryAction: PropTypes.node.isRequired,
  secondaryAction: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

const Hero = ({ title, primaryAction, secondaryAction, children }) => {
  const isWelcomeTitle = title.startsWith('Welcome to');
  return (
    <section className={styles.container}>
      <div className={styles.heroWrap}>
        <div className={styles.containerItem}>
          <h2 className={styles.heading}>
            {isWelcomeTitle ? 'Welcome to IBM' : ''}
            <span className={styles['heading-highlight']}>
              {isWelcomeTitle ? title.substring(14) : title}
            </span>
          </h2>
          <p className={styles.bodyText}>{children}</p>
          {primaryAction}
          {secondaryAction}
        </div>
        <div className={styles.containerItem}>
          <img src={MonitorExternal} alt="ICS Preview" className={styles.picture} />
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
export default Hero;
